import t from "@ext/localization/locale/translate";
import { Badge } from "@ui-kit/Badge";

interface CardNotLoadedProps {
	onClone: () => void;
}

const CardNotLoaded = ({ onClone }: CardNotLoadedProps) => (
	<button
		aria-label={t("catalog.clone")}
		className="group/clone grid cursor-pointer appearance-none rounded-full border-0 bg-transparent p-0"
		onClick={onClone}
		type="button"
	>
		<Badge
			className="col-start-1 row-start-1 justify-self-start bg-status-neutral-bg-hover transition-opacity duration-150 ease-out group-hover/card:opacity-0 group-focus-visible/clone:opacity-0 motion-reduce:transition-none"
			size="sm"
			startIcon="cloud"
		/>
		<Badge
			className="col-start-1 row-start-1 justify-self-start gap-0 font-normal opacity-0 transition-[opacity,background-color] duration-150 ease-out group-hover/card:opacity-100 group-hover/clone:bg-status-neutral-hover group-focus-visible/clone:opacity-100 motion-reduce:transition-none"
			focus="high"
			size="sm"
			startIcon="cloud-download"
		>
			<span className="grid grid-cols-[0fr] overflow-hidden transition-[grid-template-columns] duration-200 [transition-timing-function:cubic-bezier(0.23,1,0.32,1)] group-hover/card:grid-cols-[1fr] group-focus-visible/clone:grid-cols-[1fr] motion-reduce:transition-none">
				<span className="min-w-0 whitespace-nowrap">
					<span className="pl-1">{t("catalog.clone")}</span>
				</span>
			</span>
		</Badge>
	</button>
);

export default CardNotLoaded;
